import React from 'react'
import moment from 'moment'

type Props = {
  image: String,
  email: String,
  organization: String,
  settings: { delivery_based_access: Boolean },
  lastActive: String,
}

const CarrierRow = ({ image, email, organization, settings, lastActive }: Props) => (
  <tr>
    <td style={{ padding: 30 }}>{image ? <img style={{ width: '100%', height: 'auto' }} src={image} alt="carrier" /> : <div style={{ color: 'red', fontWeight: 'bold' }}>BILD SAKNAS</div>}</td>
    <td>{organization}</td>
    <td>{email}</td>
    <td>{settings && settings.delivery_based_access === false ? 'DBF' : 'DBT'}</td>
    <td>
      {lastActive
        ? moment(lastActive)
            .locale('sv')
            .format('llll')
        : ''}
    </td>
  </tr>
)

export default React.memo(CarrierRow)
